import Table from "../../../../components/table/table";
import { observer } from "mobx-react";
import LocaleTableRaw from "../locale-table-row/locale-table-row";
import LocaleStore from "../../stores/locale-store";

interface IlocaleListProps {
 localesList: LocaleStore[];
}

const LocaleList: React.FC<IlocaleListProps> = observer(({localesList}) => {
    
    return (
         <Table
                    columns={[
                        {
                            content: "LANGUAGE",
                            sortable: false,
                            width: {
                                value: 150,
                                type: "px"
                            }
                        },
                        {
                            content: "ENABLED / DISABLED",
                            width: {
                                value: 100,
                                type: "px"
                            }
                        },
                        {
                            content: "STATUS",
                            width: {
                                value: 1,
                                type: "fr"
                            }
                        },
                        {
                            content: "Default Language",
                            width: {
                                value: 1,
                                type: "fr"
                            }
                        },
                        {
                            content: "",
                            width: {
                                value: 60,
                                type: "px"
                            }
                        },
                    ]}
                    totalResultsTitle=""
                >
                   
                    {localesList?.length > 0 &&
                     localesList.map((locale) =>
                       <LocaleTableRaw locale = {locale} key={locale.localeName}/>
                        )
                    }

                </Table>
    );
});

export default LocaleList;
